module.exports = __webpack_public_path__ + "media/components/country-flag/static/cm-b2723805bb88df273f2a96d5f863ae31.svg";